module.exports = __webpack_public_path__ + "static/media/display-tray.68409f05.gif";